export default __webpack_public_path__ + "static/media/lamp7.debf73ed.webp";